import { ENVIRONMENT_CONSTANT } from "./env.constant";

export const ProgramFormSteps = [
  { label: "Program Info", value: "program_info" },
  { label: "Schedule", value: "program_schedule" },
  { label: "Additional Info", value: "program_additional_info" },
  { label: "Terms & Agreement", value: "program_terms" },
  { label: "Fee & Payment", value: "program_fee" },
];

export const ProgramFormStepMapper = {
  ProgramInfo: "program_info",
  ProgramSchedule: "program_schedule",
  ProgramAdditionalInfo: "program_additional_info",
  ProgramTermsAgreement: "program_terms",
  ProgramFee: "program_fee",
};


export const weeklyDaysList = [
  {label: 'Sunday', value: 'schedule.recurs_on_sunday'},
  {label: 'Monday', value: 'schedule.recurs_on_monday'},
  {label: 'Tuesday', value: 'schedule.recurs_on_tuesday'},
  {label: 'Wednesday', value: 'schedule.recurs_on_wednesday'},
  {label: 'Thursday', value: 'schedule.recurs_on_thursday'},
  {label: 'Friday', value: 'schedule.recurs_on_friday'},
  {label: 'Saturday', value: 'schedule.recurs_on_saturday'},
];

export const programScheduleTypeMapper = {
  "daily": 'Daily',
  "monthly": "Month",
  "weekly": "Week"
}

//program endpoints start
export const PROGRAM_ENDPOINT = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}programs`;
export const GET_PROGRAM_BY_ID = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}programs/get/`;
export const REGISTER_PROGRAM = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}programs/public/register`;
// export const UPDATE_PROGRAM = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}programs/`;
// export const GET_ALL_PROGRAMS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}programs`;
export const ARCHIVE_PROGRAM = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}programs/archive/`;
export const SAVE_PROGRAM_EMAIL_SETTINGS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}programs/email-settings/`;
export const GET_PROGRAM_REGISTRATIONS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}programs/registrations`;
export const GET_PROGRAM_REGISTRATION_DETAIL = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}programs/registration/details/`;
export const GET_PROGRAM_REGISTRATION_FIELDS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}programs/registration/`;
export const EXPORT_PARTICIPANTS = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}programs/export/participants/`;

// export const GET_PROGRAM_BY_ID = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}programs/`;
//program endpoints end